import * as React from "react";
import { Helmet } from "react-helmet";
import generateStructuredFaqs from "../../services/generateStructuredFaqs";
import { useEffect, useMemo } from "react";

declare global {
    interface Window {
        adsbygoogle: any;
    }
}

type SeoProps = {
    title: string;
    description: string;
    switchTitleOrder?: boolean;
    path: string;
    faqs?: { question: string; answer: string }[];
    og?: string;
};

export const Seo = ({
    title,
    description,
    switchTitleOrder,
    path,
    faqs,
    og
}: SeoProps) => {
    if (!path) return null;
    path = path.endsWith("/") ? path : `${path}/`;
    const url = `https://www.sunheron.com`;
    const completeUrl = `${url}${path}`;
    const titleText = switchTitleOrder
        ? `Sunheron | ${title}`
        : `${title} | Sunheron`;
    const ogPath = og || "sunheron-og.png";

    const [showAds, setShowAds] = React.useState(false);
    useEffect(() => {
        setTimeout(() => {
            setShowAds(true);
        },1000)
        
    }, []);

    const adScript = useMemo(() => {
        return null;
        
        // return (
        //     <script
        //         id="sh-adthrive-script"
        //         ref="sh-adthrive-script"
        //         data-no-optimize="1"
        //         data-cfasync="false"
        //     >
        //         {`(function(w, d) {
        //             w.adthrive = w.adthrive || {};
        //             w.adthrive.cmd = w.adthrive.cmd || [];
        //             w.adthrive.plugin = 'adthrive-ads-manual';
        //             w.adthrive.host = 'ads.adthrive.com';
        //             var s = d.createElement('script');
        //             s.async = true;
        //             s.referrerpolicy='no-referrer-when-downgrade';
        //             s.src = 'https://' + w.adthrive.host + '/sites/67002d57c35d3e2bcf362425/ads.min.js?referrer=' + w.encodeURIComponent(w.location.href) + '&cb=' + (Math.floor(Math.random() * 100) + 1);
        //             var n = d.getElementsByTagName('script')[0];
        //             n.parentNode.insertBefore(s, n);
        //         })(window, document);`}
        //     </script>
        // );
    }, []);

    return (
        <Helmet>
            <html lang="en" />
            <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
            <title>{titleText}</title>
            <meta name="title" content={`${titleText}`} />
            <meta name="description" content={description} />
            <meta
                name="keywords"
                content="weather, tourism, season, temperature, sea temperature, wet day, climate, precipitation, rain season, rain, sunhours, wind, humidity"
            />
            <meta name="robots" content="index, follow" />
            <meta name="language" content="en" />
            <meta name="revisit-after" content="30 days" />
            <meta
                name="google-site-verification"
                content="2kiGFT2MiCnfz2Xi33lKz14y67PWEp-Boh8Fz25VK40"
            />
            <link
                rel="apple-touch-icon"
                sizes="57x57"
                href="https://www.sunheron.com/sunheron-touch-icon-57x57.png"
            />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={completeUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={`${url}/${ogPath}`} />
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={completeUrl} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={`${url}/${ogPath}`} />
            {showAds && adScript}
            {faqs && (
                <script type="application/ld+json">
                    {generateStructuredFaqs(faqs)}
                </script>
            )}
        </Helmet>
    );
};
